import * as React from "react";
import { cn } from "../lib/utils";

const spinnerVariants =
    "w-16 h-16 border-4 border-t-4 border-slate-300 border-t-accent rounded-full animate-spin";

const LoadingSpinner = React.forwardRef((props, ref) => {
    const { className, ...rest } = props;
    return <div ref={ref} className={cn(spinnerVariants, className)} {...rest} />;
});

LoadingSpinner.displayName = "LoadingSpinner";

export { LoadingSpinner };